module.exports = __webpack_public_path__ + "static/media/ic-easy-order.93627635.svg";